if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';

      // Fee variant this product should also add when a customization
      // (text or image) is submitted. Set via data-fee-variant-id on this
      // <product-form> element from the product's linked metafield. Empty
      // on any product that isn't customizable, so this is a no-op for
      // every other product on the site.
      this.feeVariantId = this.dataset.feeVariantId || null;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      // Only attach the fee if this submission is actually using the
      // customization field (text filled in, or an image chosen).
      const shouldAddFee = this.feeVariantId && this.formHasCustomization(formData);

      if (shouldAddFee) {
        // Hidden (underscore-prefixed) property linking this line to its
        // fee variant, so cart-fee-sync.js can recalculate the correct fee
        // quantity whenever this item is removed, its quantity changes, or
        // more customized items are added later.
        formData.append('properties[_Fee Variant Id]', this.feeVariantId);
      }

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            if (shouldAddFee) {
              return this.addFeeVariant().then(() => {
                window.location = window.routes.cart_url;
              });
            }
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;

          const finishRender = (renderResponse) => {
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(renderResponse) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(renderResponse);
            }
          };

          if (shouldAddFee) {
            this.addFeeVariant()
              .then(() => this.fetchCartSections())
              .then((sections) => finishRender({ sections }))
              .catch((e) => {
                console.error('Customization fee could not be added:', e);
                finishRender(response);
              });
          } else {
            finishRender(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    // True if the customer actually used the text or image customization
    // field on this submission (so a blank/inactive field never adds a fee).
    formHasCustomization(formData) {
      for (const [key, value] of formData.entries()) {
        if (key.indexOf('properties[') !== 0) continue;
        if (value instanceof File) {
          if (value.size > 0) return true;
        } else if (typeof value === 'string' && value.trim() !== '') {
          if (key.indexOf('Customization Type') !== -1) continue;
          return true;
        }
      }
      return false;
    }

    addFeeVariant() {
      const feeFormData = new FormData();
      feeFormData.append('id', this.feeVariantId);
      feeFormData.append('quantity', '1');
      feeFormData.append('properties[_Is Fee Line]', 'true');

      const feeConfig = fetchConfig('javascript');
      feeConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete feeConfig.headers['Content-Type'];
      feeConfig.body = feeFormData;

      return fetch(`${routes.cart_add_url}`, feeConfig).then((response) => response.json());
    }

    fetchCartSections() {
      const sectionIds = this.cart.getSectionsToRender().map((section) => section.id);
      const params = sectionIds.map((id) => `section_id=${encodeURIComponent(id)}`).join('&');
      return fetch(`${window.location.pathname}?sections=${sectionIds.join(',')}`)
        .then((response) => response.json());
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
